import React, { useContext } from "react";
import Footer from "../components/Footer";
import axios from "axios";
import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Global, { isAdminAccount } from "../util/Global";
import { AlertContext } from "../util/Alerter";
import { LoaderComponent } from "../util/Loader";
import AdsComponent from "../components/Ads/AdsComponent";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import NotFound from "../components/NotFound";
import moment from "moment";
import { Chip } from "@mui/material";


const AdsDetails = () => {
  const { id } = useParams();
  const queryParams = new URLSearchParams(useLocation().search);
  const categorie = queryParams.get('categorie');
  const { t } = useTranslation();
  const [ads, setAds] = useState("");
  const [similiarAds, setsimiliarAds] = useState([])
  const [isLoading, setisLoading] = useState(true);
  const { showAlert } = useContext(AlertContext)
  const navigate = useNavigate()
  const [selectedImage, setselectedImage] = useState(0);


  const ADS_DETAILS_URL = Global.backend + "/index.php/showAnnonce";
  const RELATED_URL = Global.backend + "/index.php/homeannonce";
  const ADS_VU_URL = Global.backend + "/index.php/addVuAnnonce";




  useEffect(() => {
    setisLoading(true)

    axios.all([
      axios.post(ADS_DETAILS_URL, { userId: localStorage.getItem("id"), annonceId: id })
    ]).then(axios.spread((adsResponse) => {
      if (!adsResponse.data) {
        return
      }
      axios.post(ADS_VU_URL, { produitId: id }).catch((err) => { })
      axios.post(RELATED_URL, { categorie: categorie }).then((similiarAdsResponse) => {
        const similiarAds = similiarAdsResponse.data
        setsimiliarAds(similiarAds.filter(similiarAd => similiarAd.id != adsResponse.data.id))
      }).catch((err) => { })




      setAds(adsResponse.data);

    }))
      .catch((err) => {
        showAlert("error", t("request.errorFetchingAds"))
      })
      .finally(() => {
        setisLoading(false);
      });
  }, [id]);



  const handleBasicClick = (value) => {
    if (value === selectedImage) {
      return;
    }

    setselectedImage(value)
  };



  return (
    <div>
      <LoaderComponent isLoading={isLoading}>
        {!isLoading && (!ads ? <NotFound /> :
          <section className="ttm-row conatact-section ttm-bgcolor-grey mb_20 clearfix mt-5">
            <div className="container">
              <div className="row ttm-boxes-spacing-30px">
                <div className="col-md-6 col-sm-6 ttm-box-col-wrapper">
                  <div className="ttm_single_image-wrapper border-rad_5">

                    <div className="preview">
                      <div className="preview-pic tab-content w-50 ml-auto mr-auto">
                        <div
                          className={"tab-pane product-detail-image w-100 active"}
                          id="pic-1"

                        >
                          <img
                            src={ads.image ? `${Global.backend}/uploads/${ads.image}` : require("../assets/img/default_product.png")}
                          />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="col-md-6 col-sm-6 ttm-box-col-wrapper">
                  <div className="ttm_single_image-wrapper border-rad_5">

                    <div className="">
                      <h3>{ads.titre} </h3>
                      <div className="d-flex">
                        {ads.user.id == localStorage.getItem("id") && <h5 className="text-primary h-100">({t("yourAd")})</h5>}
                        {isAdminAccount() && <Chip className="ml-2" label={t(ads.etat ? (ads.etat == -1 ? "ads.rejected" : "ads.approved") : "ads.waiting")} color={ads.etat ? (ads.etat == -1 ? "error" : "success") : "info"} />}
                      </div>
                    </div>

                    <div className="mb-3">
                      <h6 className="d-inline">{t("ads.category")} : </h6>
                      <p className="details-p d-inline m-0 p-0 ">
                        {t("ads.categories." + ads.categorie)}
                      </p>
                    </div>


                    <div className="mb-3">
                      <h6 className="d-inline">{t("ads.publishDate")} : </h6>
                      <p className="details-p d-inline m-0 p-0 ">
                        {ads.date + " (" + moment(ads.date).fromNow() + ")"}
                      </p>
                    </div>

                    <div className="mb-3">
                      <h6 className="d-inline">{t("ads.views")} : </h6>
                      <p className="details-p d-inline m-0 p-0 ">
                        {ads.vu || 0}
                      </p>
                    </div>



                    <div className="mb-3">
                      <h6 className="d-inline">{t("ads.description")} : </h6>
                      <p className="details-p d-inline m-0 p-0 ">
                        {ads.description}
                      </p>
                    </div>





                  </div>
                </div>
              </div>


              <div className="row">
                <div className="ttm-bgcolor-white p-30 border-rad_5 margin_top15" style={{ width: "100%" }}>
                  <Tabs
                    style={{ width: "100%" }}
                  >
                    <TabList>
                      <Tab>{t("publisherInfos")}</Tab>
                    </TabList>





                    <TabPanel>
                      <div style={{ marginTop: 20 }}>
                        <h4>{t("publisherInfos")} </h4>
                      </div>
                      <div className="row">
                        <div className="col-md-5">




                          <div className="ligne">
                            <span className="titleligne">{t("ads.publisherName")}:</span>
                            <span className="descriptionligne">{ads.user.entreprise?.nom}</span>
                          </div>





                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit11.1")} :</span>
                            <span className="descriptionligne">{t("user.activities." + ads.user?.entreprise?.activite)}</span>
                          </div>




                          <div className="ligne">
                            <span className="titleligne">{t("user.pays")}:</span>
                            <span className="descriptionligne">{ads.user.entreprise?.pays}</span>
                          </div>



                          <div className="ligne">
                            <span className="titleligne">{t("user.address")}:</span>
                            <span className="descriptionligne">{ads.user.entreprise?.adresse}</span>
                          </div>


                          <div className="ligne">
                            <span className="titleligne">{t("user.city")}  </span>
                            <span className="descriptionligne">{ads.user.entreprise?.ville}</span>
                          </div>


                          <div className="ligne">
                            <span className="titleligne">{t("user.postalCode")}  </span>
                            <span className="descriptionligne">{ads.user.entreprise?.code_postal}</span>
                          </div>



                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit13.1")}: </span>
                            <span className="descriptionligne">{ads.user?.entreprise?.email}</span>
                          </div>







                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit15.1")}: </span>
                            <span className="descriptionligne">{ads.user.entreprise?.tel}</span>
                          </div>






                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit16.1")}: </span>
                            <span className="descriptionligne">{ads.user.civilite ? t("user.civilities." + ads.user.civilite) : ""} {ads.user.prenom} {ads.user.nom}</span>
                          </div>





                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit17.1")}  </span>
                            <span className="descriptionligne">{t("user.services." + ads.user.service)} {"/"} {t("user.functions." + ads.user.fonction)}</span>
                          </div>




                          <div className="row">
                            <button
                              className="ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor d-print-none"

                              onClick={() => {
                                navigate(`/entreprise/${ads.user?.entreprise?.nom}`)
                              }}
                            >
                              <span>{t("aboutCompany")} <i className="fa fa-chevron-right"></i></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </TabPanel>




                  </Tabs>
                </div>

              </div>


              {(similiarAds.length > 0) && (
                <div className="row">
                  <div style={{
                    borderBottom: "1px solid lightgray", marginTop: 50,
                    width: "100%"
                  }}>
                    <h4>{t("similiarProducts")}</h4>
                  </div>

                  <AdsComponent items={similiarAds} itemsPerPage={4} />

                </div>
              )}
            </div>
          </section >
        )}
      </LoaderComponent>

      <Footer />
    </div>
  );
};

export default AdsDetails;
